import { Route, Switch } from 'react-router-dom';
import DashletStatistic from './appDahsboard/dashletStatistic';
import Settings from './Settings';
import { DealPanorama, TicketPanorama } from './appPanorama';
import AppStock from './appStock/appStock';
import AppBook from 'src/scenes/Book';
import AppPlanning from './appPlanning/appPlanning';
import AppStats from './appStats/appStats';
import AppRankings from './appStats/appRankings';
import AppProposal from './appProposal/appProposal';
import AppOrderForm from './appOrderForm/appOrderForm';
import AppDossier from './appDossier/appDossier';
import AppProduction from './appProduction/appProduction';
import AppPrep from './appPrep/appPrep';
import AppInstallation from './appInstallation/appInstallation';
import AppBilling from './appBilling/appBilling';
import AppTicketList from './appTicketList/appTicketList';
import MyWall from './components/wall/wall';
import DisplayPost from './components/display/displayPost';
import Profile from './Profile';
import DisplayProduct from './components/display/displayProduct';
import DisplaySupplier from './components/display/displaySupplier';
import DisplayContact from './components/display/displayContact';
import DisplayCustomerTechnical from './components/display/displayCustomerTechnical';
import DisplayCustomer from './components/display/displayCustomer';
import DisplayDeal from './components/display/displayDeal';
import DisplayTicket from './components/display/displayTicket';
import DisplayTask from './components/display/displayTask';
import DisplayAppointment from './components/display/displayAppointment';
import DisplayReminder from './components/display/displayReminder';
import DisplayNote from './components/display/displayNote';
import React from 'react';
import { createUseStyles } from '../theming';
import RequestRouter from './Requests/RequestRouter';
import CrmRouter from './CrmRouter';
import useDrawer from '../hooks/useDrawer';
import InterventionOrderRouter from './InterventionOrder/InterventionOrderRouter';
import TicketRouter from './Tickets/TicketRouter';
import AppointmentRouter from './Collaborative/Appointments/AppointmentRouter';
import SiteRedirection from './RedirectNewToLegacy/SiteRedirection';
import ContactRedirection from './RedirectNewToLegacy/ContactRedirection';
import AppHome from './appHome/appHome';
import DeliveryOrderRouter from 'src/scenes/DeliveryOrder/DeliveryOrderRouter';
import Site from 'src/scenes/components/display/Site';
import Search from 'src/scenes/Search';

const useStyles = createUseStyles((theme) => ({
  root: {
    background: '#f4f7fa',
    transition: 'transform 0.5s ease-out',
    '& > div': {
      width: '100%',
    },
  },
  [theme.breakpoints.up('lg')]: {
    root: {
      marginLeft: ({ fixed }) => theme.components.Drawer[fixed ? 'defaultWidth' : 'collapseWidth'],
    },
  },
}));

const DashboardRouter = ({ user, history, match, openToast, toggleBlackOut }) => {
  const { menuType } = useDrawer();
  const classes = useStyles({ fixed: menuType === 'fixed' });

  return (
    <div className={classes.root}>
      <Switch>
        <Route path={`${match.url}/crm`} component={CrmRouter} />

        <Route exact path={`${match.url}/home`} render={(props) => <AppHome {...props} history={history} />} />

        <Route
          exact
          path={`${match.url}`}
          render={(props) => (
            <DashletStatistic
              {...props}
              user={user}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/settings`}
          render={() => (
            <Settings
              user={user}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route path={`${match.url}/search`} render={(props) => <Search user={user} {...props} />} />

        <Route path={`${match.url}/requests`} render={(props) => <RequestRouter {...props} />} />

        <Route path={`${match.url}/appointments`} render={(props) => <AppointmentRouter {...props} />} />

        <Route path={`${match.url}/tickets`} render={(props) => <TicketRouter {...props} />} />

        <Route
          path={`${match.url}/panorama/deal`}
          render={(props) => (
            <DealPanorama
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/panorama/ticket`}
          render={(props) => (
            <TicketPanorama
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/intervention-orders`}
          render={(props) => (
            <InterventionOrderRouter
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route path={`${match.url}/delivery-orders`} render={(props) => <DeliveryOrderRouter history={history} />} />

        <Route
          path={`${match.url}/stock`}
          render={(props) => (
            <AppStock
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/book`}
          render={(props) => (
            <AppBook
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/planning`}
          render={(props) => (
            <AppPlanning
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/stats`}
          render={(props) => (
            <AppStats
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/rankings`}
          render={(props) => (
            <AppRankings
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/proposal/:id?`}
          render={(props) => (
            <AppProposal
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/orderform/:id?`}
          render={(props) => (
            <AppOrderForm
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/dossier/:id?`}
          render={(props) => (
            <AppDossier
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/production/:id?`}
          render={(props) => (
            <AppProduction
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/preparation/:id?`}
          render={(props) => (
            <AppPrep
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/setup/:id?`}
          render={(props) => (
            <AppInstallation
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/billing/:id?`}
          render={(props) => (
            <AppBilling
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/ticketlist/:id?`}
          render={(props) => (
            <AppTicketList
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/wall/:id?`}
          render={(props) => (
            <MyWall
              {...props}
              onRelative={false}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/:relativeTo/wall/:id?`}
          render={(props) => (
            <MyWall
              {...props}
              onRelative={true}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/post/:id?`}
          render={(props) => (
            <DisplayPost
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route path={`${match.url}/user/:id?`} render={(props) => <Profile me={user} {...props} history={history} />} />

        <Route
          path={`${match.url}/productHardware/:id?`}
          render={(props) => (
            <DisplayProduct
              {...props}
              productType='hardware'
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/productVirtual/:id?`}
          render={(props) => (
            <DisplayProduct
              {...props}
              productType='virtual'
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/supplierHardware/:id?`}
          render={(props) => (
            <DisplaySupplier
              {...props}
              supplierType='hardware'
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/supplierVirtual/:id?`}
          render={(props) => (
            <DisplaySupplier
              {...props}
              supplierType='virtual'
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/contact/:id?`}
          render={(props) => (
            <DisplayContact
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/customer/site/:id?`}
          render={(props) => (
            <Site
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
              {...props}
            />
          )}
        />

        <Route
          path={`${match.url}/customer/technical/:id?`}
          render={(props) => (
            <DisplayCustomerTechnical
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route path={`${match.url}/sites/:id`} render={(props) => <SiteRedirection {...props} />} />

        <Route path={`${match.url}/contacts/:id`} render={(props) => <ContactRedirection {...props} />} />

        <Route
          path={`${match.url}/customer/:id?`}
          render={(props) => (
            <DisplayCustomer
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />

        <Route
          path={`${match.url}/deal/:id?`}
          render={(props) => (
            <DisplayDeal
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/ticket/:id?`}
          render={(props) => (
            <DisplayTicket
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/task/:id?`}
          render={(props) => (
            <DisplayTask
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/appointment/:id?`}
          render={(props) => (
            <DisplayAppointment
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/reminder/:id?`}
          render={(props) => (
            <DisplayReminder
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/note/:id?`}
          render={(props) => (
            <DisplayNote
              {...props}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
        <Route
          path={`${match.url}/testStatistics/`}
          render={(props) => (
            <DashletStatistic
              {...props}
              user={user}
              openToast={(success, message) => openToast(success, message)}
              history={history}
              toggleBlackOut={toggleBlackOut}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default DashboardRouter;
